import { store } from "common/store";
import { request } from "common/components/request";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import { pazienHistory } from "common/components/pazienHistory";

import { defaultState } from "common/reducers/email";

export const SET_STATE_FROM_URL = (data) => {
    store.dispatch({
        type: "SET_EMAIL_STORE",
        data
    });
};

export const fetchEmailDetails = ({ queryKey: [_key, args] }) => fetchEmails({ queryKey: [_key, { ...args, details: true }] });

export const fetchEmails = ({
    queryKey: [
        _key,
        {
            details = false,
            pivots = [],
            page = null,
            limit = 100,
            date_range: {
                startDate,
                endDate
            },
            qualifiers
        }
    ]
}) => {
    const q = new Qualifiers({ value: qualifiers });

    const reqData = {
        q: q.toString(),
        start: startDate,
        end: endDate,
        pivots,
        ...page && { page, limit }
    };

    return request(details ? "/admin/emails/details" : "/admin/emails", { data: reqData });
};

export const fetchDimensions = () => request("/admin/emails/dimensions");

const withNavigation = (actionCreator) => (...args) => {
    const action = actionCreator(...args);
    return (dispatch, getState) => {
        action(dispatch, getState);
        pazienHistory.navigateWithParams(`administrator/email/${getState().emails.section}/${window.encodeURIComponent(getState().emails.qualifiers)}`, { trigger: false, replace: false });
    };
};

export const EMAILS_ADD_FILTER = withNavigation(
    ({ filter }) => (dispatch, getState) => {
        dispatch({
            type: "EMAILS_UPDATE_FILTERS",
            qualifiers: `${getState().emails.qualifiers} ${filter}`.trim()
        });
    }
);

export const UPDATE_FILTERS = withNavigation(
    (qualifiers) => (dispatch, getState) => {
        dispatch({
            type: "EMAILS_UPDATE_FILTERS",
            qualifiers: qualifiers.toString()
        });
    }
);

export const TOGGLE_DETAILS = withNavigation(
    () => (dispatch, getState) => {
        dispatch({
            type: "SET_EMAIL_STORE",
            data: {
                section: getState().emails.section === "details" ? defaultState.section : "details"
            }
        });
    }
);

export const EMAILS_UPDATE_SECTION = withNavigation(
    (section) => (dispatch, getState) => {
        dispatch({
            type: "SET_EMAIL_STORE",
            data: {
                section
            }
        });
    }
);
